import styles from './Footer.module.scss'
import poweredByServify from '../../../assets/images/powered-by-servify.png'
import { postRequestAsync } from '../../../common/genericAPIs'

const Footer = ({ country }) => {
  return (
    <footer className={styles.container}>
      <div className={styles['text']}>{country || 'India'}</div>
      <img
        className={styles['image']}
        src={poweredByServify}
        alt='powered-by-servify'
        onClick={() => {
          try {
            postRequestAsync('/clean_chat', {
              consumerID: +sessionStorage.getItem('consumerID'),
            })
          } catch (e) {
            console.log(e)
          }
        }}
      />
    </footer>
  )
}

export default Footer
